// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3S0LO","tabsBox":"styles_tabsBox__zwAFk","createButton":"styles_createButton__1dZ5k"};